import axios from "axios";
import { toast } from "react-toastify";

const DownloadHandler = async (src, name = "pdf.pdf", options = {}) => {
  try {
    const isTelegramBrowser = () => {
      return typeof window.TelegramWebview !== 'undefined';
    };

    if (isTelegramBrowser()) {
      toast.info("دانلود فایل با استفاده از مرورگر تلگرام امکان پذیر نیست!");
      window.open(src, '_blank');
      return;
    }

    const toastId = toast.loading("در حال آماده‌سازی دانلود...", {
      position: "bottom-right",
    });

    const token = localStorage.getItem("token");

    const response = await axios.get(src, {
      ...options,
      responseType: 'blob',
      timeout: options.timeout || 1000000,
      params: options.params,
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...options.headers,
      },
      onDownloadProgress: (progressEvent) => {
        if (progressEvent.total) {
          const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
          );
          toast.update(toastId, {
            render: `در حال دانلود: ${percentCompleted}%`,
            type: "info",
            isLoading: true,
          });
        } else {
          const loadedMB = (progressEvent.loaded / 1024 / 1024).toFixed(2);
          toast.update(toastId, {
            render: `در حال دانلود: ${loadedMB} مگابایت دریافت شد`,
            type: "info",
            isLoading: true,
          });
        }
      },
    });

    // Get the MIME type from the response headers, fallback to generic type
    const mimeType = response.headers['content-type'] || 'application/octet-stream';
    const blob = new Blob([response.data], { type: mimeType });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', name); // Ensure download attribute is explicitly set
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);

    toast.update(toastId, {
      render: "دانلود با موفقیت آغاز شد!",
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });

  } catch (error) {
    toast.error("خطایی رخ داد: " + error.message, {
      position: "bottom-right",
    });
  }
};

export default DownloadHandler;